<template>
    <div class=" is-multiline">
      <div class="column is-5">
        <kst-input load-on-focus floating-label
          field="Search" :data="searchData" :catalog="StkSearchCatalog"
          @input="handleInput"
        />
      </div>
    </div>
</template>

<script>
import StkSearchCatalog from "../StkSearchCatalog.js";

export default {
  props: {
    searchData: Object
  },
  data: () => ({
    StkSearchCatalog: StkSearchCatalog
  }),
  methods: {
    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    }
  }
}
</script>